export enum CloudType {
  AZURE = 'AZURE',
  AWS = 'AWS',
  GCP = 'GCP',
}
